import React from 'react';

export const DialogStateContext = React.createContext([]);
export const DialogDispatchContext = React.createContext(() => {});